import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const locationSearchReducer = createReducer(initialState, {
  LOCATION_SEARCH_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  LOCATION_SEARCH_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  LOCATION_SEARCH_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default locationSearchReducer;
